import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a2bc22d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "form-input",
  for: "name"
}
const _hoisted_2 = {
  key: 0,
  class: "warning-note"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  id: "name",
  class: "form-input form-element",
  name: "from_name",
  placeholder: "Enter your name"
}, null, -1))
const _hoisted_4 = {
  class: "form-input",
  for: "email"
}
const _hoisted_5 = {
  key: 0,
  class: "warning-note"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  id: "email",
  class: "form-input form-element",
  name: "from_email",
  placeholder: "Enter your email"
}, null, -1))
const _hoisted_7 = {
  class: "form-input",
  for: "phone number"
}
const _hoisted_8 = {
  key: 0,
  class: "warning-note"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<input type=\"text\" id=\"phoneNumber\" class=\"form-input form-element\" name=\"from_phoneNumber\" placeholder=\"Enter your phone number\" data-v-4a2bc22d><label class=\"form-input\" for=\"position\" data-v-4a2bc22d>Position:</label><input type=\"text\" id=\"position\" class=\"form-input form-element\" name=\"from_position\" placeholder=\"Enter your position\" data-v-4a2bc22d><label class=\"form-input\" for=\"organization\" data-v-4a2bc22d>Organization:</label><input type=\"text\" id=\"organization\" class=\"form-input form-element\" name=\"from_organization\" placeholder=\"Enter your organization\" data-v-4a2bc22d><label class=\"form-input\" for=\"typeOfService\" data-v-4a2bc22d>Type of Service:</label><select id=\"service-type-dropdown\" class=\"form-element form-input\" name=\"from_service\" data-v-4a2bc22d><option value=\"undefined\" hidden data-v-4a2bc22d>select from options</option><option data-v-4a2bc22d>Training For Evaluation Personnel</option><option data-v-4a2bc22d>Consultation for school district</option><option data-v-4a2bc22d>Other Consultations</option><option data-v-4a2bc22d>Not listed</option></select><label class=\"form-input\" for=\"message\" data-v-4a2bc22d>Message</label><textarea id=\"contact-message-textarea\" class=\"form-input\" name=\"message\" data-v-4a2bc22d></textarea><button id=\"email-form-submit-btn\" class=\"email-button static-medium m-1\" type=\"submit\" data-v-4a2bc22d> Send </button>", 10)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultModal = _resolveComponent("ResultModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ResultModal, {
      "is-open": _ctx.openResultModal,
      successOrFailure: _ctx.emailSuccess,
      message: _ctx.resultMessage,
      onCloseModal: _ctx.resetForm
    }, null, 8, ["is-open", "successOrFailure", "message", "onCloseModal"]),
    _createElementVNode("form", {
      id: "contact-form",
      class: "flex column align-c mlr-auto",
      onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sendEmail($event)))
    }, [
      _createElementVNode("label", _hoisted_1, [
        _createTextVNode("Name: "),
        (_ctx.warnings.fromName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Name required"))
          : _createCommentVNode("", true)
      ]),
      _hoisted_3,
      _createElementVNode("label", _hoisted_4, [
        _createTextVNode("Email: "),
        (_ctx.warnings.emailPhone)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Need email or phone number"))
          : _createCommentVNode("", true)
      ]),
      _hoisted_6,
      _createElementVNode("label", _hoisted_7, [
        _createTextVNode("Phone: "),
        (_ctx.warnings.emailPhone)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Need email or phone number"))
          : _createCommentVNode("", true)
      ]),
      _hoisted_9
    ], 32)
  ], 64))
}